import { pickRandom } from '@engineering11/utility'
import { C_JOB_PATTERN_CATEGORY_MAP, CJobPattern, CJobPatternToCategory } from './c-job.model'

export function generateRandomTraitPattern() {
  return pickRandom(Object.values(CJobPattern), 1)[0]
}

export function getPatternCategoryProperties(traitName?: string): CJobPatternToCategory | undefined {
  return C_JOB_PATTERN_CATEGORY_MAP[traitName as CJobPattern]
}
